(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["su-announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function pad(n) {
      return n < 10 ? '0' + n : String(n);
    }

    function tick(el) {
      var deadline = Date.parse(el.dataset.deadline);
      if (isNaN(deadline)) {
        el.textContent = '';
        return true;
      }

      var diff = deadline - Date.now();
      if (diff <= 0) {
        el.textContent = el.dataset.expiredText || '';
        return true;
      }

      var s = Math.floor(diff / 1000);
      var d = Math.floor(s / 86400);
      var h = Math.floor((s % 86400) / 3600);
      var m = Math.floor((s % 3600) / 60);
      var sec = s % 60;

      var parts = [];
      if (d > 0) parts.push(d + (el.dataset.days || 'd'));
      parts.push(pad(h) + (el.dataset.hours || 'h'));
      parts.push(pad(m) + (el.dataset.minutes || 'm'));
      if (d === 0) parts.push(pad(sec) + (el.dataset.seconds || 's'));

      el.textContent = parts.join(' ');
      return false;
    }

    function start(el) {
      if (el.dataset.suStarted) return;
      el.dataset.suStarted = 'true';
      if (tick(el)) return;
      var id = setInterval(function () {
        if (tick(el)) clearInterval(id);
      }, 1000);
    }

    function init() {
      document.querySelectorAll('[data-su-countdown]').forEach(start);
    }

    document.addEventListener('DOMContentLoaded', init);
    document.addEventListener('shopify:section:load', init);
    init();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["su-donate"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function setup(root) {
      if (root.dataset.suDonateReady) return;
      root.dataset.suDonateReady = 'true';

      var tabs = root.querySelectorAll('[data-su-mode]');
      var amounts = root.querySelectorAll('[data-su-amount]');
      var cta = root.querySelector('[data-su-donate-cta]');
      var line = root.querySelector('[data-su-line]');
      var errorEl = root.querySelector('[data-su-donate-error]');

      var state = {
        mode: 'monthly',
        amount: amounts.length ? Number(amounts[0].dataset.suAmount) : 0,
      };

      var preselected = root.querySelector('.su-donate__amount.is-selected');
      if (preselected) state.amount = Number(preselected.dataset.suAmount);

      function renderCta() {
        if (!cta) return;
        var label = state.mode === 'monthly' ? root.dataset.ctaMonthly : root.dataset.ctaOnce;
        cta.textContent = (label || '').replace('{amount}', (root.dataset.currency || '') + state.amount);
      }

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          state.mode = tab.dataset.suMode;
          tabs.forEach(function (t) {
            var active = t === tab;
            t.classList.toggle('is-active', active);
            t.setAttribute('aria-selected', active ? 'true' : 'false');
          });
          renderCta();
        });
      });

      amounts.forEach(function (button) {
        button.addEventListener('click', function () {
          state.amount = Number(button.dataset.suAmount);
          amounts.forEach(function (b) {
            b.classList.toggle('is-selected', b === button);
          });
          if (line) line.textContent = button.dataset.line || '';
          renderCta();
        });
      });

      if (cta) {
        cta.addEventListener('click', function () {
          var variant = state.mode === 'monthly' ? root.dataset.monthlyVariant : root.dataset.onceVariant;
          if (!variant) {
            if (errorEl) {
              errorEl.textContent = 'No donation product selected for this option.';
              errorEl.hidden = false;
            }
            return;
          }

          var unit = parseFloat(root.dataset.unit) || 1;
          var quantity = Math.max(1, Math.round(state.amount / unit));
          var routeRoot = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';

          cta.disabled = true;
          if (errorEl) errorEl.hidden = true;

          fetch(routeRoot + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(variant), quantity: quantity }] }),
          })
            .then(function (res) {
              return res.json().then(function (data) {
                if (!res.ok) throw new Error(data.description || data.message || 'Cart error');
                return data;
              });
            })
            .then(function () {
              if (root.dataset.cartBehaviour === 'checkout') {
                window.location.href = '/checkout';
                return;
              }
              window.location.href = routeRoot + 'cart';
            })
            .catch(function (err) {
              if (errorEl) {
                errorEl.textContent = err.message;
                errorEl.hidden = false;
              }
            })
            .finally(function () {
              cta.disabled = false;
            });
        });
      }

      renderCta();
    }

    function init() {
      document.querySelectorAll('[data-su-donate]').forEach(setup);
    }

    document.addEventListener('DOMContentLoaded', init);
    document.addEventListener('shopify:section:load', init);
    init();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["su-impact-calculator"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function fmt(locale, value, decimals) {
      try {
        return new Intl.NumberFormat(locale || 'en', {
          minimumFractionDigits: decimals || 0,
          maximumFractionDigits: decimals || 0,
        }).format(value);
      } catch (e) {
        return String(Math.round(value));
      }
    }

    function plural(n, one, many) {
      return n === 1 ? one : many;
    }

    function setup(root) {
      if (root.dataset.suCalcReady) return;
      root.dataset.suCalcReady = 'true';

      var d = root.dataset;
      var peopleInput = root.querySelector('[data-su-people]');
      var yearsInput = root.querySelector('[data-su-years]');
      if (!peopleInput || !yearsInput) return;

      var out = {
        people: root.querySelector('[data-su-people-label]'),
        years: root.querySelector('[data-su-years-label]'),
        rolls: root.querySelector('[data-su-rolls]'),
        money: root.querySelector('[data-su-money]'),
        trees: root.querySelector('[data-su-trees]'),
        water: root.querySelector('[data-su-water]'),
        life: root.querySelector('[data-su-life]'),
      };

      function render() {
        var people = parseInt(peopleInput.value, 10) || 1;
        var years = parseInt(yearsInput.value, 10) || 1;

        var rollsPerYear = parseFloat(d.rollsPerYear) || 0;
        var price = parseFloat(d.pricePerRoll) || 0;
        var reduction = (parseFloat(d.reduction) || 0) / 100;
        var perTree = parseFloat(d.rollsPerTree) || 1;
        var litres = parseFloat(d.litresPerRoll) || 0;
        var locale = d.locale || 'en';

        var rolls = people * years * rollsPerYear * reduction;

        if (out.people) {
          out.people.textContent = people + ' ' + plural(people, d.peopleSingular, d.peoplePlural);
        }
        if (out.years) {
          out.years.textContent = years + ' ' + plural(years, d.yearSingular, d.yearPlural);
        }
        if (out.rolls) out.rolls.textContent = fmt(locale, rolls);
        if (out.money) out.money.textContent = (d.currency || '') + fmt(locale, rolls * price);
        if (out.trees) out.trees.textContent = fmt(locale, rolls / perTree, rolls / perTree < 10 ? 1 : 0);
        if (out.water) out.water.textContent = fmt(locale, rolls * litres);
        if (out.life && d.lifetimeNote) {
          out.life.textContent = d.lifetimeNote.replace('{years}', years).replace('{people}', people);
        }
      }

      peopleInput.addEventListener('input', render);
      yearsInput.addEventListener('input', render);
      render();
    }

    function init() {
      document.querySelectorAll('[data-su-calc]').forEach(setup);
    }

    document.addEventListener('DOMContentLoaded', init);
    document.addEventListener('shopify:section:load', init);
    init();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["su-merch-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function setup(root) {
      if (root.dataset.suMerchReady) return;
      root.dataset.suMerchReady = 'true';

      root.querySelectorAll('[data-su-merch-form]').forEach(function (form) {
        form.addEventListener('submit', function (event) {
          if (!window.fetch) return;
          event.preventDefault();

          var button = form.querySelector('button');
          var idInput = form.querySelector('input[name="id"]');
          if (!idInput) return;

          var label = button ? button.textContent : '';
          if (button) button.disabled = true;

          var routeRoot = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';

          fetch(routeRoot + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(idInput.value), quantity: 1 }] }),
          })
            .then(function (res) {
              if (!res.ok) throw new Error('cart');
              return res.json();
            })
            .then(function () {
              var behaviour = root.dataset.cartBehaviour;
              if (behaviour === 'cart') {
                window.location.href = routeRoot + 'cart';
                return;
              }
              document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
              document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { source: 'su-merch' } }));
              if (button) {
                button.dataset.added = 'true';
                setTimeout(function () {
                  button.textContent = label;
                  delete button.dataset.added;
                }, 1600);
              }
            })
            .catch(function () {
              form.submit();
            })
            .finally(function () {
              if (button) button.disabled = false;
            });
        });
      });
    }

    function init() {
      document.querySelectorAll('[data-su-merch]').forEach(setup);
    }

    document.addEventListener('DOMContentLoaded', init);
    document.addEventListener('shopify:section:load', init);
    init();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["su-movement-nav"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function refreshCount() {
      var nodes = document.querySelectorAll('[data-su-cart-count]');
      if (!nodes.length || !window.fetch) return;
      var routeRoot = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';

      fetch(routeRoot + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (res) {
          return res.json();
        })
        .then(function (cart) {
          nodes.forEach(function (node) {
            node.textContent = cart.item_count;
          });
        })
        .catch(function () {});
    }

    function init() {
      document.querySelectorAll('[data-su-locale] select').forEach(function (select) {
        if (select.dataset.suBound) return;
        select.dataset.suBound = 'true';
        select.addEventListener('change', function () {
          select.form.submit();
        });
      });
    }

    document.addEventListener('DOMContentLoaded', init);
    document.addEventListener('shopify:section:load', init);
    document.addEventListener('cart:refresh', refreshCount);
    document.addEventListener('cart:update', refreshCount);
    init();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["su-newsletter"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function setup(form) {
      if (form.dataset.suNewsReady) return;
      form.dataset.suNewsReady = 'true';

      var tagsInput = form.querySelector('[data-su-tags]');
      var topics = form.querySelectorAll('[data-su-topic]');
      if (!tagsInput || !topics.length) return;

      var base = (tagsInput.value || '')
        .split(',')
        .map(function (t) {
          return t.trim();
        })
        .filter(Boolean);

      function sync() {
        var selected = [];
        topics.forEach(function (input) {
          if (input.checked) selected.push(input.value);
        });
        tagsInput.value = base.concat(selected).join(',');
      }

      topics.forEach(function (input) {
        input.addEventListener('change', sync);
      });
      sync();
    }

    function init() {
      document.querySelectorAll('[data-su-news]').forEach(setup);
    }

    document.addEventListener('DOMContentLoaded', init);
    document.addEventListener('shopify:section:load', init);
    init();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["su-pocket-buybox"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function setup(root) {
      if (root.dataset.suBuyboxReady) return;
      root.dataset.suBuyboxReady = 'true';

      var form = root.querySelector('[data-su-form]');
      if (!form) return;

      var hidden = form.querySelector('[data-su-hidden-id]');
      var addon = form.querySelector('[data-su-addon]');
      var submit = form.querySelector('[data-su-submit]');
      var errorEl = form.querySelector('[data-su-error]');

      function selectedVariant() {
        var checked = form.querySelector('[data-su-tier]:checked');
        return checked ? checked.value : hidden && hidden.value;
      }

      function syncHidden() {
        if (hidden) hidden.value = selectedVariant() || '';
      }

      form.querySelectorAll('[data-su-tier]').forEach(function (input) {
        input.addEventListener('change', syncHidden);
      });
      syncHidden();

      form.addEventListener('submit', function (event) {
        if (!window.fetch) return;
        event.preventDefault();

        var items = [];
        var variant = selectedVariant();
        if (!variant) return;
        items.push({ id: Number(variant), quantity: 1 });
        if (addon && addon.checked && addon.value) {
          items.push({ id: Number(addon.value), quantity: 1 });
        }

        var label = submit ? submit.textContent : '';
        if (submit) {
          submit.disabled = true;
          submit.textContent = '…';
        }
        if (errorEl) errorEl.hidden = true;

        fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items }),
        })
          .then(function (res) {
            return res.json().then(function (data) {
              if (!res.ok) throw new Error(data.description || data.message || 'Cart error');
              return data;
            });
          })
          .then(function () {
            var behaviour = root.dataset.cartBehaviour;
            if (behaviour === 'checkout') {
              window.location.href = '/checkout';
              return;
            }
            if (behaviour === 'cart') {
              window.location.href = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart';
              return;
            }
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { source: 'su-buybox' } }));
            if (submit) submit.textContent = label;
          })
          .catch(function (err) {
            if (errorEl) {
              errorEl.textContent = err.message;
              errorEl.hidden = false;
            }
            if (submit) submit.textContent = label;
          })
          .finally(function () {
            if (submit) submit.disabled = false;
          });
      });
    }

    function init() {
      document.querySelectorAll('[data-su-buybox]').forEach(setup);
    }

    document.addEventListener('DOMContentLoaded', init);
    document.addEventListener('shopify:section:load', init);
    init();
  })();

  } catch(e) { console.error(e); }
})();
})();
